import { IUser } from 'models/User';
import { DEMO_WALLET_COLLECTOR, DEMO_WALLET_TRADER } from './constants';

const users: Record<string, IUser> = {
  [DEMO_WALLET_COLLECTOR.toLowerCase()]: {
    _id: 'demo-user-collector',
    name: 'Cosmic Collector',
    wallet: DEMO_WALLET_COLLECTOR,
    email: 'collector@demo.local',
    nfts: {
      character: 4,
      companion: 2,
      land: 3,
      item: 5,
      resource: 6,
      structure: 2,
    },
  },
  [DEMO_WALLET_TRADER.toLowerCase()]: {
    _id: 'demo-user-trader',
    name: 'Star Trader',
    wallet: DEMO_WALLET_TRADER,
    email: 'trader@demo.local',
    nfts: {
      character: 2,
      companion: 3,
      land: 1,
      item: 4,
      resource: 3,
      structure: 4,
    },
  },
};

export default users;
